import { z } from 'zod'

export const TagSchema = z.object({
  tag_id: z.number(),
  page_id: z.number(),
  tag_normalized: z.string(),
  tag_name: z.string(),
  ts_created: z.number(),
  ts_updated: z.number(),
  active: z.boolean(),
  folder_id: z.number(),
})
